import { cva } from '@/styled-system/css';

export const propertyCardSaveButtonRecipe = cva({
  base: {
    // Use padding to extend to size of a large icon button.
    // It's ok that icon is not exactly in center of button.
    // Consult with SRP teams before changing the hit area as this could affect metrics.
    'padding': `{spacing.tighter} {spacing.tighter} {spacing.tight} {spacing.default}`,
    'transition': 'box-shadow 200ms ease',
    '& > [data-c11n-component="PropertyCard.SaveButtonIcon"]': {
      filter: 'drop-shadow({shadows.PropertyCard.SaveButton})',
      blockSize: 'icon.lg',
      inlineSize: 'icon.lg',
    },

    '& .c11n-property-card-heartIcon-outline': {
      fill: 'border.onHero.neutral-fixed',
    },

    '& .c11n-property-card-heartIcon-fill': {
      fill: 'icon.transparent.action.neutral-fixed.default',
    },

    '_hover': {
      'cursor': 'pointer',

      '& .c11n-property-card-heartIcon-outline': {
        fill: 'border.onHero.neutral-fixed',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'icon.transparent.action.neutral-fixed.hover',
      },
    },

    '_active': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'border.onHero.neutral-fixed',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'icon.transparent.action.neutral-fixed.pressed',
      },
    },

    '_focus': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'border.onHero.neutral-fixed',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'icon.transparent.action.neutral-fixed.pressed',
      },
    },

    '_focusVisible': {
      boxShadow: 'focus',
    },

    // aria-label selector added for SEO test (CDS-1992)
    '&&[aria-pressed="true"], &&[aria-label="Unsave"]': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'border.invisible',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'icon.onImpact.action.neutral-fixed.selected.default',
      },

      '_hover': {
        '& .c11n-property-card-heartIcon-outline': {
          fill: 'border.invisible',
        },

        '& .c11n-property-card-heartIcon-fill': {
          fill: 'icon.onImpact.action.neutral-fixed.hover',
        },
      },

      '_active': {
        '& .c11n-property-card-heartIcon-outline': {
          fill: 'border.invisible',
        },

        '& .c11n-property-card-heartIcon-fill': {
          fill: 'icon.onImpact.action.neutral-fixed.selected.default',
        },
      },
    },
  },
});
